import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {REPORTS_ROUTES} from '../../constants'
import {Badge, Icon} from '@therms/atalaya'
import {useCurrentUser} from '@therms/react-modules'
import {useCurrentReportsCounts} from '@src/modules/Reports/hooks/useCurrentReportCounts'
import {IoDocumentTextSharp} from 'react-icons/io5'

function ReportsMenuLink() {
  const currentUser = useCurrentUser()
  const {counts} = useCurrentReportsCounts({
    authorUserId: currentUser.id,
  })

  return (
    <MenuLink to={REPORTS_ROUTES.__ROOT__}>
      <div className="flex w-full items-center justify-between">
        <div className="gap-x-sm inline-flex items-center">
          <Icon Icon={IoDocumentTextSharp} />

          <span>Reports</span>
        </div>

        <Badge value={counts?.open} variant="info" />
      </div>
    </MenuLink>
  )
}

export {ReportsMenuLink}